import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9417f76a")

_pushScopeId("data-v-9417f76a")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "message" }, [
  /*#__PURE__*/_createVNode("div", null, "予約方法を選択してください")
], -1)
const _hoisted_2 = { class: "button-frame" }
const _hoisted_3 = { class: "button-sub-frame" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("患者を仮登録")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("して予約 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("登録患者を選択")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("して予約 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("キャンセル ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_component_white_backdrop, { show: _ctx.show }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", {
        class: ["frame", _ctx.$mq]
      }, [
        _hoisted_1,
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_normal_button, {
              type: "button",
              class: "select-button",
              state: "warning",
              onClick: _ctx.onTemporaryPatient
            }, {
              default: _withId(() => [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_normal_button, {
              type: "button",
              class: "select-button",
              state: "normal",
              onClick: _ctx.onSelectPatient
            }, {
              default: _withId(() => [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_normal_button, {
            type: "button",
            class: "cancel-button",
            state: "confirm",
            onClick: _ctx.onCancel
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 2), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }, 8, ["show"]))
})